import React from 'react';
import PropTypes from 'prop-types';
import IconBadge from './IconBadge';
import {Tree} from 'antd';
import {useSelector} from 'react-redux';
import {Link} from 'wouter';
import {ListIcon, PinIcon} from '@web/assets/icons';

CollectionsTree.propTypes = {
  ready: PropTypes.bool.isRequired,
};

function CollectionsTree(props) {
  const list = useSelector((state) => {
    return state.Collections.collections?.table;
  });

  // console.log("CollectionsTree:list:", list);
  const collapseMenu = false;
  return <Tree
    showLine
    showIcon
    blockNode
    defaultExpandedKeys={['pinned']}
    treeData={[
      // {
      //   title: <div style={{padding: "10px 0 10px"}}>
      //   {/*  <a href="/">*/}
      //   {/*  {collapseMenu ?*/}
      //   {/*    <img width={24} src="/icons/icon_sky.png" /> :*/}
      //   {/*    <img width={68} src={"/icons/line-on-dark.png"} />*/}
      //   {/*  }*/}
      //   {/*</a>*/}
      //   </div>,
      //   key: 'home',
      //   // children: [
      //   //   {
      //   //     title: 'Profile',
      //   //     key: 'profile',
      //   //     icon: <ListIcon size={18} style={{position: "relative", top: 3}} className="green-icon" />,
      //   //     children: []},
      //   // ],
      // },
      {
        title: <label style={{paddingTop: 10, marginTop: 10}}>Pinned</label>,
        key: 'pinned',
        icon: <PinIcon size={19} style={{position: "relative", top: 3}} className="green-icon" />,
        children: list?.filter?.((coll) => coll.pin && (coll.listed !== false))?.map((c) => ({
          title: c.displayName || c.collectionId,
          to: "/" + c.objectID,
          key: "/pinned:/" + c.objectID,
          collectionId: c.objectID.split("/").pop(),
          // name: c.displayName,
        }))
      },
      {
        title: 'Apps',
        key: 'apps-0',
        icon: <ListIcon size={18} style={{position: "relative", top: 3}} className="green-icon" />,
        children: [{
          title: 'Store',
          key: 'apps-store-0',
          icon: <ListIcon size={18} style={{position: "relative", top: 3}} className="green-icon" />,
          children: []},]},
      {
      title: 'Collections',
      key: 'all-9',
      icon: <ListIcon size={18} style={{position: "relative", top: 3}} className="green-icon" />,
      children: Object.values((list || [])
      .reduce(($acc, c) => {
        // console.log("CollectionsTree:collection", c.collectionId, c);
        if (c.listed === false) {
          // console.log("CollectionsTree:skipping", c.collectionId, c);
          return $acc;
        }

        c.menuGroup ?
          $acc[c.menuGroup] = {
            ...$acc[c.menuGroup] || {
              title: c.menuGroup,
              key: c.menuGroup,
            },
            children: [
              ...$acc[c.menuGroup]?.children || [], {
                title: c.displayName || c.collectionId,
                to: "/" + c.objectID,
                key: c.menuGroup + ":" + c.objectID,
                collectionId: c.objectID.split("/").pop(),
                // name: c.displayName,
              }],
          } :
          $acc[c.collectionId] = {
            ...$acc[c.collectionId] || null,
            title: c.displayName || c.collectionId,
            to: "/" + c.objectID,
            // name: c.displayName,
            key: "item:" + c.objectID,
            collectionId: c.objectID.split("/").pop(),
          };
        return $acc;
      }, {}))
    },
      {
        title: 'Tools',
        key: 'tools-0',
        icon: <ListIcon size={18} style={{position: "relative", top: 3}} className="green-icon" />,
        children: []},
      {
        title: 'Workflows',
        key: 'workflows-9',
        icon: <ListIcon size={18} style={{position: "relative", top: 3}} className="green-icon" />,
        children: []},
      {
        title: 'Assistant',
        key: '+1415-555-1212',
        icon: <ListIcon size={18} style={{position: "relative", top: 3}} className="green-icon" />,
        children: [
          {
            title: 'Agent',
            key: '+1415-407-6105',
            icon: <ListIcon size={18} style={{position: "relative", top: 3}} className="green-icon" />,
            children: [ {
              title: 'Feed',
              key: 'feed-2',
              icon: <ListIcon size={18} style={{position: "relative", top: 3}} className="green-icon" />,
              children: []},
            ]},
        ]},
      {
        title: 'Upgrade',
        key: 'feed-1',
        icon: <ListIcon size={18} style={{position: "relative", top: 3}} className="green-icon" />,
        children: []},
    ]}
    titleRender={(source) => {
      return source.to ?
        <IconBadge status="success" collectionId={source.collectionId} dot offset={[10, 10]}>
          <Link className="text-color no-underline" to={source?.to}>{source?.title}</Link>
        </IconBadge> :
        source?.title;
    }}
    // onExpand={(expandedKeys, {expanded, node, ...s}) => {
    //   console.log("expanded:", {expandedKeys, expanded, node, s});
    //   expanded &&
    //   dispatch(collectionActions.sync(...node.children.filter((c) => !!c.collectionId).map((c) => c.collectionId)));
    // }}
  />
}

const MemoizedCollectionsTree = React.memo(CollectionsTree,
  (prevProps, nextProps) => {
    return prevProps.ready === nextProps.ready;
  });

export default MemoizedCollectionsTree;
